import React, { memo } from "react";
import { Handle, Node, NodeProps, Position } from "@xyflow/react";
import { Placement } from "./blueprint";

export type AddNodeData = {
    placement: Placement;
    label?: string;
};

export type AddFlowNode = Node<AddNodeData, 'add'>;

/** The "+" where a module can be added. */
const AddNode = ({ data }: NodeProps<AddFlowNode>) => (
    <div className="text-center" style={{ width: 140 }}>
        <Handle type="target" position={Position.Left} style={{ top: 40, opacity: 0 }} />
        <div
            role="button"
            className="rounded-circle d-inline-flex align-items-center justify-content-center border border-2 border-dashed text-muted bg-light"
            style={{ width: 80, height: 80 }}
        >
            <i className="ri-add-line fs-1" />
        </div>
        {data.label && <div className="mt-1 small text-muted">{data.label}</div>}
    </div>
);

export default memo(AddNode);
